import { animationTimiings } from "./constants"

export const getNearestCellFromOtherCell = (
  cellOrder: number,
  cells: number[]
) => {
  for (let i = 0; i < cells.length; i++) {
    const item = cells[i]
    if (item > cellOrder) return item
  }
  return cells[0]
}

export const getActivePlayerByGameObject = (game: IGame) =>
  game.situation.players.find((player) => player.id === game.situation.turn)

export const advanceToCell = (order: number): BonusCardChangeFunction => {
  return (game) => {
    const activePlayer = game.situation.players.find(
      (player) => player.id === game.situation.turn
    )
    const newPosition = order
    const players = game.situation.players.map((player) =>
      player.id === game.situation.turn
        ? {
            ...player,
            positionAfterAnimation: newPosition,
          }
        : player
    )
    return {
      game: { ...game, situation: { ...game.situation, players } },
      postCardDrawEvents: [
        {
          type: "piece-movement",
          movementType: "no-jump",
          from: activePlayer.position,
          to: newPosition,
          playerOrder: activePlayer.order,
        },
      ],
      customEvents: [],
    }
  }
}
export const advanceToNearestUtility = (game: IGame) => {
  const utilityStores = [12, 28]
  const activePlayer = game.situation.players.find(
    (player) => player.id === game.situation.turn
  )
  const nearestStoreOrder = getNearestCellFromOtherCell(
    activePlayer.position,
    utilityStores
  )
  return advanceToCell(nearestStoreOrder)
}

export const advanceToNearestStation = (game: IGame) => {
  const utilityStores = [5, 15, 25, 35]

  const activePlayer = game.situation.players.find(
    (player) => player.id === game.situation.turn
  )
  const nearestStoreOrder = getNearestCellFromOtherCell(
    activePlayer.position,
    utilityStores
  )
  return advanceToCell(nearestStoreOrder)
}
interface IMoneyTransfer {
  money: number
  from?: PlayerOrder
  to?: PlayerOrder
}
export const jailFreeCardChangeFunction: BonusCardChangeFunction = (game) => {
  const players: IPlayer[] = game.situation.players.map((player) =>
    player.id === game.situation.turn
      ? {
          ...player,
          jailFreeCards: [...player.jailFreeCards, "chance"],
        }
      : player
  )

  return {
    game: { ...game, situation: { ...game.situation, players } },
    postCardDrawEvents: [],
    customEvents: [],
  }
}
export const goToJailCardFunction: BonusCardChangeFunction = (game) => {
  const activePlayer = game.situation.players.find(
    (player) => player.id === game.situation.turn
  )
  const players = game.situation.players.map((player) =>
    player.id === game.situation.turn
      ? {
          ...player,
          positionAfterAnimation: 10,
          inJail: true,
          inJailTurns: 1,
        }
      : player
  )
  return {
    game: { ...game, situation: { ...game.situation, players } },
    postCardDrawEvents: [
      {
        type: "piece-movement",
        movementType: "no-jump",
        from: activePlayer.position,
        to: 10,
        playerOrder: activePlayer.order,
      },
      {
        type: "run-go-to-jail-animation",
        playerOrder: activePlayer.order,
        startPosition: activePlayer.position,
      },
    ],
    customEvents: [],
  }
}
export const moneyTransferFunction = (
  transfers: IMoneyTransfer[]
): BonusCardChangeFunction => {
  return (game) => {
    const activePlayer = game.situation.players.find(
      (player) => player.id === game.situation.turn
    )

    const players = JSON.parse(JSON.stringify(game.situation.players))
    transfers.forEach(
      ({ from = activePlayer.order, to = activePlayer.order, money }) => {
        players.forEach((player) => {
          if (to === player.order) {
            player.money += money
          }
          if (from === player.order) {
            player.money -= money
          }
        })
      }
    )

    return {
      game: {
        ...game,
        situation: { ...game.situation, players, endTurnEnabled: true },
      },
      postCardDrawEvents: transfers.map(
        ({ from = activePlayer.order, to = activePlayer.order, money }) =>
          ({
            type: "money-transfer",
            money,
            from,
            to,
          }) as IStateChangeEventFromSeverToClient
      ),
      customEvents: [],
    }
  }
}
